/* Daily Energy Club: mobile menu, sticky bar, 28-day calendar fill, flavor picker, membership checkout. No dependencies. */
(function () {
  var head = document.querySelector('[data-dec-head]');
  var burger = document.querySelector('[data-dec-burger]');
  if (head && burger) {
    burger.addEventListener('click', function () {
      var open = head.classList.toggle('open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // sticky mobile bar: after the first screen, hidden while the join box is on screen
  var sticky = document.querySelector('[data-dec-sticky]');
  var join = document.querySelector('[data-dec-join]');
  if (sticky) {
    var joinVisible = false;
    if (join && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { joinVisible = e[0].isIntersecting; tick(); }).observe(join);
    }
    var tick = function () { sticky.classList.toggle('show', window.scrollY > 500 && !joinVisible); };
    window.addEventListener('scroll', tick, { passive: true });
    tick();
  }

  // 28-day calendar: fills day by day when it scrolls into view
  var cals = document.querySelectorAll('[data-dec-cal]');
  var fill = function (cal) {
    var days = cal.querySelectorAll('i');
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    days.forEach(function (d, i) { setTimeout(function () { d.classList.add('on'); }, still ? 0 : 45 * i); });
  };
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { fill(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.35 });
    cals.forEach(function (c) { io.observe(c); });
  } else { cals.forEach(fill); }

  // flavor picker: swaps the photo and (list mode) the customer tag; honors ?flavor=<slug>.
  // Live mode: the radios are the membership form's "id" field (variant id), so the form posts the chosen flavor.
  if (join) {
    var img = join.querySelector('[data-dec-join-img]');
    var tags = join.querySelector('[data-dec-join-tags]');
    var radios = join.querySelectorAll('input[data-dec-flavor]');
    var apply = function (r) {
      if (img && r.dataset.img) img.src = r.dataset.img;
      if (tags) tags.value = tags.dataset.base + ', dec-flavor-' + r.dataset.slug;
    };
    radios.forEach(function (r) { r.addEventListener('change', function () { apply(r); }); });
    var want = new URLSearchParams(window.location.search).get('flavor');
    radios.forEach(function (r) { if (want && r.dataset.slug === want) { r.checked = true; apply(r); } });
  }

  // membership checkout: empty the cart first (the store is shared with other brands and the member buys exactly one tin),
  // then let the form post to /cart/add, which sends the buyer to checkout.
  document.querySelectorAll('[data-dec-buy]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (form.dataset.sent) return;
      e.preventDefault();
      form.dataset.sent = '1';
      var btn = form.querySelector('button[type="submit"]');
      if (btn) btn.disabled = true;
      var go = function () { form.submit(); };
      try { fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' }).then(go, go); } catch (err) { go(); }
    });
  });
  // coming back from checkout with the back button restores the page: make the button usable again
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-dec-buy]').forEach(function (form) {
      delete form.dataset.sent;
      var btn = form.querySelector('button[type="submit"]');
      if (btn) btn.disabled = false;
    });
  });

  // mints scroll showcase. The page scrolls natively: a sticky stage + requestAnimationFrame only READS the scroll
  // position (no wheel/touch handlers, no preventDefault). Frames play over the first 64 % of the section, the copy
  // fades in over the next 21 %, the rest holds the finished shot.
  document.querySelectorAll('[data-dec-scroll]').forEach(function (root) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var canvas = root.querySelector('canvas');
    var ctx = canvas && canvas.getContext && canvas.getContext('2d');
    if (reduce || !ctx) return;
    var N = parseInt(root.dataset.frames, 10) || 60;
    var mobile = window.matchMedia('(max-width:820px)').matches;
    var tpl = mobile ? root.dataset.mobile : root.dataset.desktop;
    var W = mobile ? 840 : 1200, H = mobile ? 720 : 900;
    canvas.width = W; canvas.height = H;
    var copy = root.querySelector('.copy');
    var frames = new Array(N), loaded = new Array(N), started = false, drawn = -1, lastCopy = -1, want = 0, raf = 0;
    function url(i) { var n = String(i + 1); while (n.length < 3) n = '0' + n; return tpl.replace('-001.', '-' + n + '.'); }   // tpl = the asset URL of frame 001
    function load(i) {
      if (frames[i]) return;
      var im = new Image();
      im.decoding = 'async';
      im.onload = function () { loaded[i] = true; if (drawn === -1 || i === want) tick(true); };
      im.src = url(i);
      frames[i] = im;
    }
    function loadRest() {
      if (started) return; started = true;
      load(N - 1);
      var i = 1;
      (function next() { for (var k = 0; k < 6 && i < N - 1; k++) load(i++); if (i < N - 1) setTimeout(next, 60); })();
    }
    function nearest(i) {
      for (var d = 0; d < N; d++) {
        if (i - d >= 0 && loaded[i - d]) return i - d;
        if (i + d < N && loaded[i + d]) return i + d;
      }
      return -1;
    }
    function progress() {
      var r = root.getBoundingClientRect(), vh = window.innerHeight;
      var lead = vh * 0.35, total = r.height - vh + lead;
      return total <= 0 ? 1 : Math.min(1, Math.max(0, (lead - r.top) / total));
    }
    function tick(force) {
      var p = progress();
      want = Math.min(N - 1, Math.round(Math.min(1, p / 0.64) * (N - 1)));
      var i = nearest(want);
      if (i !== -1 && (i !== drawn || force)) { ctx.drawImage(frames[i], 0, 0, W, H); drawn = i; }
      var c = Math.round(Math.min(1, Math.max(0, (p - 0.64) / 0.21)) * 100) / 100;
      if (c !== lastCopy) { root.style.setProperty('--copy', c); copy.classList.toggle('is-off', c < 0.5); lastCopy = c; }
    }
    function loop() { tick(false); raf = requestAnimationFrame(loop); }
    root.classList.add('is-scroll');
    root.dataset.decScrollState = 'on';
    load(0);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        if (es[0].isIntersecting) { loadRest(); if (!raf) loop(); }
        else if (raf) { cancelAnimationFrame(raf); raf = 0; tick(true); }
      }, { rootMargin: '100% 0px 100% 0px' }).observe(root);
    } else { loadRest(); loop(); }
    root.decScroll = { loaded: function () { return loaded.filter(Boolean).length; }, drawn: function () { return drawn; } };
    var btn = root.querySelector('.btn');
    if (btn) btn.addEventListener('focus', function () {
      var r = root.getBoundingClientRect();
      window.scrollTo(0, window.pageYOffset + r.top + r.height - window.innerHeight);
    });
  });
})();

/* Gift pop-up (2026-10-05): email first, then a scratch card, then the gift. Every visitor gets the same gift (data-code).
   The code is kept in localStorage; the join box then sends it to checkout (return_to=/checkout?discount=CODE).
   Once per session. ?nopop=1 never opens it, ?pop=1 opens it at once (testing). Native scrolling is only locked while it is open. */
(function () {
  var KEY = 'dec_gift', SEEN = 'dec_pop_seen';
  var get = function (store, k) { try { return window[store].getItem(k); } catch (e) { return null; } };
  var set = function (store, k, v) { try { window[store].setItem(k, v); } catch (e) {} };

  // a claimed gift follows the visitor to the join box
  function applyGift() {
    var code = get('localStorage', KEY);
    if (!code) return;
    document.querySelectorAll('[data-dec-buy]').forEach(function (form) {
      var ret = form.querySelector('input[name="return_to"]');
      if (ret) ret.value = '/checkout?discount=' + encodeURIComponent(code);
      var note = form.querySelector('[data-dec-gift-note]');
      if (note) note.classList.add('on');
      var row = form.querySelector('[data-gift-value]');
      if (row) row.textContent = row.getAttribute('data-gift-value');
    });
  }
  applyGift();

  var root = document.querySelector('[data-dec-pop]');
  if (!root) return;
  var qs = new URLSearchParams(window.location.search);
  var force = qs.get('pop') === '1';
  if (!force && (qs.get('nopop') === '1' || get('sessionStorage', SEEN) || get('localStorage', KEY))) return;

  var card = root.querySelector('.dec-pop-card');
  var form = root.querySelector('[data-dec-pop-form]');
  var msg = root.querySelector('[data-dec-pop-msg]');
  var sub = root.querySelector('[data-dec-pop-sub]');
  var status = root.querySelector('[data-dec-pop-status]');
  var canvas = root.querySelector('canvas');
  var ticket = root.querySelector('[data-dec-pop-ticket]');
  var ctx = canvas && canvas.getContext && canvas.getContext('2d');
  var opened = false, lastFocus = null, done = false;

  function step(name) {
    root.setAttribute('data-step', name);
    if (sub && sub.dataset[name]) sub.textContent = sub.dataset[name];
    if (status) status.textContent = sub ? sub.textContent : '';
  }

  function paintFoil() {
    if (!ctx) return;
    var r = ticket.getBoundingClientRect(), dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.max(2, Math.round(r.width * dpr)); canvas.height = Math.max(2, Math.round(r.height * dpr));
    var w = canvas.width, h = canvas.height;
    ctx.globalCompositeOperation = 'source-over';
    var g = ctx.createLinearGradient(0, 0, w, h);
    g.addColorStop(0, '#FFC84D'); g.addColorStop(.5, '#FFB81F'); g.addColorStop(1, '#F2A400');
    ctx.fillStyle = g; ctx.fillRect(0, 0, w, h);
    ctx.strokeStyle = 'rgba(12,18,58,.10)'; ctx.lineWidth = 6 * dpr;
    for (var x = -h; x < w; x += 22 * dpr) { ctx.beginPath(); ctx.moveTo(x, h); ctx.lineTo(x + h, 0); ctx.stroke(); }
    ctx.fillStyle = '#0C123A'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    ctx.font = '800 ' + Math.round(Math.min(w / 9.5, h / 4.5)) + 'px Archivo, Arial, sans-serif';
    ctx.fillText(root.dataset.foil || 'SCRATCH HERE', w / 2, h / 2);
  }

  function cleared() {
    var w = canvas.width, h = canvas.height, d, n = 0, t = 0;
    try { d = ctx.getImageData(0, 0, w, h).data; } catch (e) { return 1; }
    for (var y = 4; y < h; y += 8) for (var x = 4; x < w; x += 8) { t++; if (d[(y * w + x) * 4 + 3] < 40) n++; }
    return t ? n / t : 0;
  }

  function win() {
    if (done) return; done = true;
    set('localStorage', KEY, root.dataset.code || '');
    step('won');
    applyGift();
    var go = root.querySelector('[data-dec-pop-go]');
    if (go) go.focus({ preventScroll: true });
  }

  function scratching() {
    if (!ctx) { win(); return; }
    var down = false, last = null, moves = 0;
    var pos = function (e) { var r = canvas.getBoundingClientRect(); return { x: (e.clientX - r.left) * canvas.width / r.width, y: (e.clientY - r.top) * canvas.height / r.height }; };
    var rub = function (a, b) {
      ctx.globalCompositeOperation = 'destination-out';
      ctx.strokeStyle = '#000';   // full alpha: the stripe colour left on the context would only thin the foil
      ctx.lineCap = 'round'; ctx.lineJoin = 'round'; ctx.lineWidth = canvas.width / 7;
      ctx.beginPath(); ctx.moveTo(a.x, a.y); ctx.lineTo(b.x + .01, b.y + .01); ctx.stroke();
    };
    canvas.addEventListener('pointerdown', function (e) { if (done) return; down = true; last = pos(e); rub(last, last); try { canvas.setPointerCapture(e.pointerId); } catch (x) {} e.preventDefault(); });
    canvas.addEventListener('pointermove', function (e) {
      if (!down || done) return;
      var p = pos(e); rub(last, p); last = p;
      if (++moves % 6 === 0 && cleared() > .45) win();
    });
    var up = function () { if (down && !done && cleared() > .45) win(); down = false; };
    canvas.addEventListener('pointerup', up); canvas.addEventListener('pointercancel', up);
  }

  function subscribe(email) {
    var body = { data: { type: 'subscription', attributes: { custom_source: 'DEC gift pop-up', profile: { data: { type: 'profile', attributes: {
      email: email, properties: { dec_gift: root.dataset.code || '' },
      subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
      relationships: { list: { data: { type: 'list', id: root.dataset.list } } } } };
    try {
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(root.dataset.company), { method: 'POST', keepalive: true,
        headers: { 'content-type': 'application/vnd.api+json', revision: '2025-07-15' }, body: JSON.stringify(body) }).catch(function () {});
    } catch (e) {}
    // No Shopify customer is created here: Shopify answers a background post to /contact with 400 (checked live 2026-10-05).
    // The Klaviyo list is the record of who signed up.
  }

  function close() {
    if (!opened) return;
    opened = false;
    root.classList.remove('is-in');
    document.documentElement.classList.remove('dec-pop-open');
    document.removeEventListener('keydown', onKey, true);
    setTimeout(function () { root.hidden = true; }, 260);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  function onKey(e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(card.querySelectorAll('a[href],button,input'), function (el) { return el.offsetParent !== null && !el.disabled; });
    if (!f.length) return;
    var first = f[0], lastEl = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); lastEl.focus(); }
    else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); first.focus(); }
  }

  function open() {
    if (opened || done) return;
    opened = true;
    set('sessionStorage', SEEN, '1');
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('dec-pop-open');
    paintFoil();
    requestAnimationFrame(function () { root.classList.add('is-in'); });
    document.addEventListener('keydown', onKey, true);
    try { card.focus({ preventScroll: true }); } catch (e) {}
  }

  root.addEventListener('click', function (e) {
    if (e.target === root || e.target.closest('[data-dec-pop-close]')) { close(); return; }
    if (e.target.closest('[data-dec-pop-reveal]')) { win(); return; }
    var go = e.target.closest('[data-dec-pop-go]');
    if (go) {
      var here = document.querySelector('[data-dec-join]');
      if (here) { e.preventDefault(); close(); here.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    }
  });
  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    var input = form.querySelector('input[type="email"]'), email = (input.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { msg.textContent = root.dataset.bad || 'Check the email address.'; input.focus(); return; }
    msg.textContent = '';
    subscribe(email);
    step('scratch');
    scratching();
    var rev = root.querySelector('[data-dec-pop-reveal]');
    if (rev) rev.focus({ preventScroll: true });
  });

  root.decPop = { open: open, close: close };
  if (force) { open(); return; }
  var delay = (parseInt(root.dataset.delay, 10) || 6) * 1000;
  var timer = setTimeout(open, delay);
  var onScroll = function () {
    var max = document.documentElement.scrollHeight - window.innerHeight;
    if (max > 0 && window.scrollY / max > .30) { clearTimeout(timer); window.removeEventListener('scroll', onScroll); open(); }
  };
  window.addEventListener('scroll', onScroll, { passive: true });
})();

/* Klaviyo (added 2026-10-05): the membership list form also subscribes the email to the list "DEC - Membership waitlist"
   (WTLveb) in the Davision Klaviyo account (UneZNa), with the chosen flavor. The Shopify customer form still submits as before. */
(function () {
  var form = document.getElementById('dec-join-form');
  if (!form) return;
  form.addEventListener('submit', function () {
    var email = form.querySelector('input[type="email"]');
    if (!email || !email.value) return;
    var flavor = document.querySelector('input[name="dec-flavor"]:checked');
    var body = { data: { type: 'subscription', attributes: { custom_source: 'DEC membership form', profile: { data: { type: 'profile', attributes: {
      email: email.value.trim(), properties: { dec_flavor: flavor ? flavor.value : '' },
      subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
      relationships: { list: { data: { type: 'list', id: 'WTLveb' } } } } };
    try {
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=UneZNa', { method: 'POST', keepalive: true,
        headers: { 'content-type': 'application/vnd.api+json', revision: '2025-07-15' }, body: JSON.stringify(body) });
    } catch (e) {}
  });
})();
